/**
 * "O atendente está olhando para esta aba agora?"
 *
 * Espelha exatamente a guarda do /sw.js (`visibilityState === 'visible' &&
 * focused`): o service worker só engole o push quando uma janela está assim.
 * Marcar leitura ou tocar som com critério diferente criaria os dois erros que
 * um mensageiro não pode cometer — "visto" enviado com a aba escondida, ou
 * push silenciado sem ninguém ter visto a mensagem.
 */
export function janelaAtiva(): boolean {
  if (typeof document === 'undefined') return false
  return document.visibilityState === 'visible' && document.hasFocus()
}

/** Chama `acao` sempre que a aba passa a estar ativa. Devolve o cleanup. */
export function aoFicarAtiva(acao: () => void): () => void {
  const handler = () => {
    if (janelaAtiva()) acao()
  }
  document.addEventListener('visibilitychange', handler)
  window.addEventListener('focus', handler)
  return () => {
    document.removeEventListener('visibilitychange', handler)
    window.removeEventListener('focus', handler)
  }
}
